import { useEffect, useRef, useState } from "react";
import {
  Phone,
  Mail,
  Menu,
  X,
  ChevronDown,
  Factory,
  Cloud,
  Info,
  Users,
} from "lucide-react";
import {
  Code,
  Smartphone,
  RefreshCw,
  ChartColumn,
  Briefcase,
  Database,
  Settings,
  Monitor,
  Globe,
  Headphones,
  Layers,
  Zap,
  ArrowRight,
  Server,
} from "lucide-react";
import { FaFacebook, FaFacebookSquare } from "react-icons/fa";
import { useLocation } from "react-router-dom";

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  // Desktop dropdown states
  const [servicesDropdownOpen, setServicesDropdownOpen] = useState(false);
  const [odooDropdownOpen, setOdooDropdownOpen] = useState(false);

  // Mobile dropdown states (separate from desktop)
  const [mobileServicesOpen, setMobileServicesOpen] = useState(false);
  const [mobileOdooOpen, setMobileOdooOpen] = useState(false);

  const servicesDropdownRef = useRef(null);
  const odooDropdownRef = useRef(null);

  // Close desktop dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        servicesDropdownRef.current &&
        !servicesDropdownRef.current.contains(event.target)
      ) {
        setServicesDropdownOpen(false);
      }
      if (
        odooDropdownRef.current &&
        !odooDropdownRef.current.contains(event.target)
      ) {
        setOdooDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // const isActive = (path) => window.location.pathname === path;
    const location = useLocation();

  const normalizePath = (path) => path.replace(/\/+$/, "");

  const isActive = (path) => {
    const currentPath = normalizePath(location.pathname);
    const targetPath = normalizePath(path);

    if (targetPath === "") return currentPath === "";

    return currentPath === targetPath || currentPath.startsWith(targetPath + "/");
  };

  return (
    <header className="main-sticky-header sticky top-0 z-50 w-full">
      {/* Main Header */}
      <div className="main-sticky-header sticky top-0 z-50 bg-white shadow-md">
        <div>
          <div className="container mx-auto px-4">
            <div className="flex justify-between items-center py-4">
              <a href="/" className="flex-shrink-0">
                <img
                  src="/assets/images/logos/tissa-logo.png"
                  alt="STISSA Technology LLP (TISSA Technology) Logo"
                  className="h-16"
                />
              </a>

              {/* Desktop Menu */}
              <nav className="hidden lg:flex items-center space-x-8">
                <a
                  href="/"
                  className={
                    isActive("/")
                      ? "text-blue-600 text-lg font-bold"
                      : "text-gray-700 hover:text-blue-600 transition-colors font-bold"
                  }
                >
                  Home
                </a>

                 <a
                  href="/about-us"
                  className={
                    isActive("/about-us")
                      ? "text-blue-600 text-lg font-bold"
                      : "text-gray-700 hover:text-blue-600 transition-colors font-bold"
                  }
                >
                  About Us
                </a>


                {/* Services Dropdown */}
                <div className="relative" ref={servicesDropdownRef}>
                  <button
                    className={isActive("/services") ? "flex items-center text-blue-600 font-bold text-lg transition-colors" : "flex items-center text-gray-700 hover:text-blue-600 font-bold transition-colors"}
                    onClick={() =>
                      setServicesDropdownOpen(!servicesDropdownOpen)
                    }
                    aria-expanded={servicesDropdownOpen}
                    aria-controls="services-popover-panel"
                  >
                    Services
                    <ChevronDown
                      size={16}
                      className={`ml-1 transition-transform ${
                        servicesDropdownOpen ? "rotate-180" : ""
                      }`}
                    />
                  </button>

                  {servicesDropdownOpen && (
                    <div
                      className="absolute left-1/2 z-50 mt-2 transform -translate-x-1/2 rounded-lg bg-white shadow-xl border border-gray-100"
                      id="services-popover-panel"
                      tabIndex="-1"
                      style={{ width: "330px" }}
                    >
                      <div className="p-4">
                        <div>
                          <h3 className="text-lg font-bold text-gray-800 mb-4 border-b border-gray-100 pb-2">
                            Our Services
                          </h3>
                          <ul className="space-y-1">
                            {[
                              {
                                href: "/services/custom-software-development/",
                                icon: <Code className="w-5 h-5" />,
                                label: "Custom Software Development",
                              },
                              {
                                href: "/services/mobile-app-development/",
                                icon: <Smartphone className="w-5 h-5" />,
                                label: "Mobile Application Development",
                              },
                              {
                                href: "/services/api-development",
                                icon: <Layers className="w-5 h-5" />,
                                label: "API Development",
                              },
                              {
                                href: "/services/integration/",
                                icon: <RefreshCw className="w-5 h-5" />,
                                label: "Integration",
                              },
                              {
                                href: "/services/data-analytics/",
                                icon: <ChartColumn className="w-5 h-5" />,
                                label: "Data Analytics",
                              },
                              {
                                href: "/services/big-data/",
                                icon: <Database className="w-5 h-5" />,
                                label: "Big Data",
                              },
                              {
                                href: "/services/ai-ml-genai",
                                icon: <Monitor className="w-5 h-5" />,
                                label: "AI, ML & GEN AI",
                              },
                              {
                                href: "/services/sap-services",
                                icon: <Server className="w-5 h-5" />,
                                label: "SAP Services",
                              },
                              // {
                              //   href: "/services/sap-services/sap-btp",
                              //   icon: <Cloud className="w-5 h-5" />,
                              //   label: "SAP BTP",
                              // },
                              {
                                href: "/services/odoo-services/",
                                icon: <Globe className="w-5 h-5" />,
                                label: "Odoo Services",
                              },
                              {
                                href: "/services/consulting/",
                                icon: <Briefcase className="w-5 h-5" />,
                                label: "Consulting",
                              },
                            ].map((item, idx) => (
                              <li key={idx}>
                                <a
                                  href={item.href}
                                  className="flex items-center text-gray-700 hover:text-blue-600 transition-colors duration-200 py-1 group"
                                >
                                  <span className="bg-gray-100 w-6 h-6 rounded-lg flex items-center justify-center mr-2 group-hover:bg-blue-100 transition-colors duration-200">
                                    {item.icon}
                                  </span>
                                  <span>{item.label}</span>
                                </a>
                              </li>
                            ))}
                          </ul>
                        </div>
                      </div>
                      <div className="bg-gray-50 px-6 py-4 rounded-b-lg border-t border-gray-100 flex justify-between items-center">
                        <a
                          href="/services/"
                          className="flex items-center text-sm text-lg text-primary hover:text-primary-dark transition-colors duration-200"
                        >
                          View All Services
                          <ArrowRight className="ml-1" />
                        </a>
                      </div>
                    </div>
                  )}
                </div>

                <a
                  href="/products"
                  className={
                    isActive("/products")
                      ? "text-blue-600 text-lg font-bold"
                      : "text-gray-700 hover:text-blue-600 transition-colors font-bold"
                  }
                >
                  Products
                </a>

                <a
                  href="/career"
                  className={
                    isActive("/career")
                      ? "text-blue-600 text-lg font-bold"
                      : "text-gray-700 hover:text-blue-600 transition-colors font-bold"
                  }
                >
                  Career
                </a>

                <a
                  href="/contact-us"
                  className={
                    isActive("/contact-us")
                      ? "text-blue-600 text-lg font-bold"
                      : "text-gray-700 hover:text-blue-600 transition-colors font-bold"
                  }
                >
                  Contact Us
                </a>
              </nav>

              <div className="col-md-2 hidden-xs hidden-sm">
                <ul className=" hidden sm:flex space-x-3">
                  <li className="">
                    <a
                      target="_blank"
                      href="https://www.linkedin.com/company/tissatech"
                    >
                      <img
                        src="/assets/images/social-icons/linkedin.png"
                        className="w-6 h-6"
                      />
                    </a>
                  </li>
                  <li className="">
                    <a
                      target="_blank"
                      href="https://www.facebook.com/tissatech/"
                    >
                      <img
                        src="/assets/images/social-icons/facebook.png"
                        className="w-6 h-6"
                      />
                    </a>
                  </li>
                  <li className="">
                    <a
                      target="_blank"
                      href="https://www.instagram.com/tissadigital/"
                    >
                      <img
                        src="/assets/images/social-icons/instagram.png"
                        className="w-6 h-6"
                      />
                    </a>
                  </li>

                  <li className="">
                    <a
                      target="_blank"
                      href="https://www.youtube.com/channel/UCZ4SzB9n66H4NpKJEtIQkzw"
                    >
                      <img
                        src="/assets/images/social-icons/youtube.png"
                        className="w-6 h-6"
                      />
                    </a>
                  </li>
                </ul>
              </div>

              {/* Mobile Menu Button */}
              <div className="lg:hidden">
                <button
                  onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                  className="text-gray-700 hover:text-blue-600 focus:outline-none"
                >
                  {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
                </button>
              </div>
            </div>
          </div>
        </div>
        {mobileMenuOpen && (
          <div className="lg:hidden bg-white border-t">
            <div className="container mx-auto px-4 py-3">
              <nav className="flex flex-col space-y-4">
                <a
                  href="/"
                  className={
                    isActive("/")
                      ? "text-blue-600 text-lg py-2"
                      : "text-gray-700 py-2"
                  }
                  onClick={() => setMobileMenuOpen(false)}
                >
                  Home
                </a>

                <a
                  href="/about-us"
                  className={
                    isActive("/about-us")
                      ? "text-blue-600 text-lg py-2"
                      : "text-gray-700 py-2"
                  }
                  onClick={() => setMobileMenuOpen(false)}
                >
                  About Us
                </a>

                {/* Services Dropdown */}
                <div>
                  <button
                    className="flex items-center justify-between w-full text-gray-700 py-2"
                    onClick={() => setMobileServicesOpen(!mobileServicesOpen)}
                  >
                    Services
                    <ChevronDown
                      size={16}
                      className={`transition-transform ${
                        mobileServicesOpen ? "rotate-180" : ""
                      }`}
                    />
                  </button>
                  {mobileServicesOpen && (
                    <div className="pl-4 mt-2 space-y-2">
                      <a
                        href="/services/custom-software-development"
                        className="block py-2 text-gray-700"
                        onClick={() => setMobileMenuOpen(false)}
                      >
                        Custom Software Development
                      </a>
                      <a
                        href="/services/mobile-app-development"
                        className="block py-2 text-gray-700"
                        onClick={() => setMobileMenuOpen(false)}
                      >
                        Mobile Application Development
                      </a>
                      <a
                        href="/services/api-development"
                        className="block py-2 text-gray-700"
                        onClick={() => setMobileMenuOpen(false)}
                      >
                        API Development
                      </a>
                      <a
                        href="/services/integration"
                        className="block py-2 text-gray-700"
                        onClick={() => setMobileMenuOpen(false)}
                      >
                        Integration
                      </a>
                      <a
                        href="/services/data-analytics"
                        className="block py-2 text-gray-700"
                        onClick={() => setMobileMenuOpen(false)}
                      >
                        Data Analytics
                      </a>
                      <a
                        href="/services/big-data"
                        className="block py-2 text-gray-700"
                        onClick={() => setMobileMenuOpen(false)}
                      >
                        Big Data
                      </a>
                      <a
                        href="/services/ai-ml-genai"
                        className="block py-2 text-gray-700"
                        onClick={() => setMobileMenuOpen(false)}
                      >
                        AI, ML & GEN AI
                      </a>
                      <a
                        href="/services/sap-services"
                        className="block py-2 text-gray-700"
                        onClick={() => setMobileMenuOpen(false)}
                      >
                        SAP Services
                      </a>
                      {/* <a
                        href="/services/sap-services/sap-btp"
                        className="block py-2 text-gray-700"
                        onClick={() => setMobileMenuOpen(false)}
                      >
                        SAP BTP
                      </a> */}
                      <a
                        href="/services/odoo-services"
                        className="block py-2 text-gray-700"
                        onClick={() => setMobileMenuOpen(false)}
                      >
                        Odoo Services
                      </a>
                      <a
                        href="/services/consulting"
                        className="block py-2 text-gray-700"
                        onClick={() => setMobileMenuOpen(false)}
                      >
                        Consulting
                      </a>
                    </div>
                  )}
                </div>

                <a
                  href="/products"
                  className={
                    isActive("/products")
                      ? "text-blue-600 text-lg py-2"
                      : "text-gray-700 py-2"
                  }
                  onClick={() => setMobileMenuOpen(false)}
                >
                  Products
                </a>

                <a
                  href="/career"
                  className={
                    isActive("/career")
                      ? "text-blue-600 text-lg py-2"
                      : "text-gray-700 py-2"
                  }
                  onClick={() => setMobileMenuOpen(false)}
                >
                  Career
                </a>

                <a
                  href="/contact-us"
                  className="bg-blue-600 text-white px-6 py-3 rounded text-center hover:bg-blue-700 transition-colors"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  Contact Us
                </a>
              </nav>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
